module.exports = __webpack_public_path__ + "static/media/bottled_cocktails.8135e17d.jpeg";